import { IonLabel } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { useTheme } from "react-jss";
import { useHistory } from "react-router";
import { AppRoutes } from "../../constants/appRoutes";
import { AboutSecurityControllerStyle } from "./controllerStyle.jss";

export interface IAboutSecurityProps {
    fromRequest?: boolean;
}

export const AboutSecurityController = ({ fromRequest }: IAboutSecurityProps) => {
    const { t } = useTranslation("common");

    const theme = useTheme();
    const style = AboutSecurityControllerStyle({ theme });
    const history = useHistory();
    return (
        <IonLabel
            className={style.text}
            onClick={() => {
                fromRequest ? history.push(AppRoutes.REQUEST_ABOUT_SECURITY) : history.push(AppRoutes.ABOUT_SECURITY);
            }}
        >
            {t("MESSAGES.SECURITY_ACTION")}
        </IonLabel>
    );
};
